import { PaginationFilterRequest } from './core.model';
import { utcToJSDate } from '@/utils/date-time';
import { AdvanceShareStyleCategoryEnum } from './advance-share-style.model';

export const ELITES_POINT_TYPE_ID = 1;

export function pointTypeFromJson(json: any): PointType {
  return {
    ...json,
    createdAt: utcToJSDate(json.createdAt),
  } as PointType;
}

export interface PointType {
  id: number;
  key: string;
  name: string;
  description?: string;
  iconUrl?: string;
  isActive: boolean;
  createdAt: Date;
}

export interface UpsertPointType {
  id?: number;
  key: string;
  name: string;
  description?: string;
  iconUrl?: string;
  isActive: boolean;
}

export class PointTypePaginationFilter extends PaginationFilterRequest {
  isActive?: boolean;
}

/** One restriction row: exactly one of styleType / styleId / category is set. */
export interface PointTypeAiStyle {
  id: number;
  pointTypeId: number;
  styleType?: number;
  styleId?: number;
  category?: AdvanceShareStyleCategoryEnum;
}

export interface UpsertPointTypeAiStyle {
  styleType?: number;
  styleId?: number;
  category?: AdvanceShareStyleCategoryEnum;
}
